export const MAX_RETRY_COUNT = 10
export const RETRY_INTERVAL = 250
